"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.Status = exports.OfferAction = exports.Currency = exports.CoBrandPartner = exports.OfferType = exports.Channel = exports.BillingPeriod = void 0;
var BillingPeriod;
(function (BillingPeriod) {
    BillingPeriod["DAILY"] = "DAILY";
    BillingPeriod["WEEKLY"] = "WEEKLY";
    BillingPeriod["MONTHLY"] = "MONTHLY";
    BillingPeriod["ANNUAL"] = "ANNUAL";
    BillingPeriod["BIANNUAL"] = "BIANNUAL";
    BillingPeriod["QUARTERLY"] = "QUARTERLY";
    BillingPeriod["PAY_PERIOD"] = "PAY_PERIOD";
})(BillingPeriod = exports.BillingPeriod || (exports.BillingPeriod = {}));
var Channel;
(function (Channel) {
    Channel["D2C"] = "D2C";
    Channel["NETWORK"] = "NETWORK";
    Channel["GROUP"] = "GROUP";
})(Channel = exports.Channel || (exports.Channel = {}));
var OfferType;
(function (OfferType) {
    OfferType["STANDARD"] = "STANDARD";
    OfferType["LEGACY"] = "LEGACY";
    OfferType["EXPERIMENTAL"] = "EXPERIMENTAL";
})(OfferType = exports.OfferType || (exports.OfferType = {}));
var CoBrandPartner;
(function (CoBrandPartner) {
    CoBrandPartner["PRIMERICA"] = "PRIMERICA";
    CoBrandPartner["SOFI"] = "SOFI";
    CoBrandPartner["NEWITY"] = "NEWITY";
})(CoBrandPartner = exports.CoBrandPartner || (exports.CoBrandPartner = {}));
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(Currency = exports.Currency || (exports.Currency = {}));
var OfferAction;
(function (OfferAction) {
    OfferAction["CREATED"] = "CREATED";
    OfferAction["UPDATED"] = "UPDATED";
    OfferAction["PRODUCTS_ADDED"] = "PRODUCTS_ADDED";
    OfferAction["PRODUCTS_UPDATED"] = "PRODUCTS_UPDATED";
    OfferAction["DELETED"] = "DELETED";
    OfferAction["STATUS_UPDATED"] = "STATUS_UPDATED";
    OfferAction["AVAILABLE_LOCALITIES_UPDATED"] = "AVAILABLE_LOCALITIES_UPDATED";
    OfferAction["MIGRATION_UPDATE"] = "MIGRATION_UPDATE";
    OfferAction["PROVISION_TYPE_CHANGE"] = "PROVISION_TYPE_CHANGE";
})(OfferAction = exports.OfferAction || (exports.OfferAction = {}));
var Status;
(function (Status) {
    Status["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    Status["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    Status["AVAILABLE_FOR_SALE"] = "AVAILABLE_FOR_SALE";
    Status["ENROLLABLE"] = "ENROLLABLE";
    Status["GRANDFATHERED"] = "GRANDFATHERED";
})(Status = exports.Status || (exports.Status = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://offers.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Offers API
 * @version v1
 * @baseUrl https://offers.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags OfferMigrations
             * @name OfferMigrationsMigrateOffer
             * @request POST:/v1/brands/{brandName}/offers/migrate
             * @secure
             */
            offerMigrationsMigrateOffer: (brandName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/migrate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OfferMigrations
             * @name OfferMigrationsMigrateGroupOffer
             * @request POST:/v1/brands/{brandName}/offers/groupMigrate
             * @secure
             */
            offerMigrationsMigrateGroupOffer: (brandName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/groupMigrate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersGetOffers
             * @request GET:/v1/brands/{brandName}/offers
             * @secure
             */
            offersGetOffers: (brandName, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersCreateOffer
             * @request POST:/v1/brands/{brandName}/offers
             * @secure
             */
            offersCreateOffer: (brandName, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersGetOffer
             * @request GET:/v1/brands/{brandName}/offers/{offerId}
             * @secure
             */
            offersGetOffer: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersUpdateOffer
             * @request PUT:/v1/brands/{brandName}/offers/{offerId}
             * @secure
             */
            offersUpdateOffer: (brandName, offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersDeleteOffer
             * @request DELETE:/v1/brands/{brandName}/offers/{offerId}
             * @secure
             */
            offersDeleteOffer: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersAddProducts
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/addProducts
             * @secure
             */
            offersAddProducts: (brandName, offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/addProducts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersUpdateProducts
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/updateProducts
             * @secure
             */
            offersUpdateProducts: (brandName, offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/updateProducts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersUpdateAvailableLocalities
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/updateAvailableLocalities
             * @secure
             */
            offersUpdateAvailableLocalities: (brandName, offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/updateAvailableLocalities`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersPendingApproval
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/pendingApproval
             * @secure
             */
            offersPendingApproval: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/pendingApproval`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersMakeEnrollable
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/makeEnrollable
             * @secure
             */
            offersMakeEnrollable: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/makeEnrollable`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersReadyForSale
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/readyForSale
             * @secure
             */
            offersReadyForSale: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/readyForSale`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersGrandfather
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/grandfather
             * @secure
             */
            offersGrandfather: (brandName, offerId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/grandfather`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersValidateSelections
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/validateSelections
             * @secure
             */
            offersValidateSelections: (brandName, offerId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/validateSelections`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersUpdateProvisionTypeToOnFirstUse
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/products/{productId}/provisionType/onFirstUse
             * @secure
             */
            offersUpdateProvisionTypeToOnFirstUse: (brandName, offerId, productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/products/${productId}/provisionType/onFirstUse`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Offers
             * @name OffersUpdateProvisionTypeToImmediate
             * @request POST:/v1/brands/{brandName}/offers/{offerId}/products/{productId}/provisionType/immediate
             * @secure
             */
            offersUpdateProvisionTypeToImmediate: (brandName, offerId, productId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/brands/${brandName}/offers/${offerId}/products/${productId}/provisionType/immediate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags OffersJournal
             * @name OffersJournal
             * @summary Machine JWT Only
             * @request GET:/v1/offers/journal
             * @secure
             */
            offersJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offers/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags OffersJournal
             * @name OffersJournalGetJournalMaxClock
             * @request GET:/v1/offers/journal/maxClock
             * @secure
             */
            offersJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/offers/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=offers.js.map